export const isAuthenticated = state => {
    return localStorage.getItem('accessToken') !== null
}

export const getLoadingState = state => {
    return state.processing
}

export const getAuthReponse = state => {
    return state.authResponse
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js